module.exports = __webpack_public_path__ + "static/media/order_type_rate.4c7934e3.svg";